export default (name) => {
  let result = name;
  if (name.indexOf('property:') === 0) {
    result = name.replace('property:', '');
  }
  return result;
};
